import { getUserDetails, getRoleNameList } from './shared-data.service';

/**
 * Gets the aggregated permissions from localStorage.
 * The structure is { [category: string]: string[] } (sub-categories selected)
 */
export const getStoredPermissions = (): any => {
    try {
        const perms = localStorage.getItem('permissions');
        return perms ? JSON.parse(perms) : {};
    } catch (e) {
        console.error("Error parsing permissions from storage", e);
        return {};
    }
};

export const hasPermission = (category: string, subCategory: string): boolean => {
    const permissions = getStoredPermissions();
    const normalizedCategory = category.trim();
    const categoryKey = Object.keys(permissions).find(
        key => key.trim().toLowerCase() === normalizedCategory.toLowerCase()
    );

    if (!categoryKey) return false;

    const categoryPermissions = permissions[categoryKey];
    if (Array.isArray(categoryPermissions)) {
        // If the category exists but has NO sub-permissions listed, it means full access to that category
        if (categoryPermissions.length === 0) return true;
        // Otherwise, check if the specific sub-permission is included
        return categoryPermissions.some(
            (p: string) => p.trim().toLowerCase() === subCategory.trim().toLowerCase()
        );
    }
    return false;
};

/**
 * Checks if the user has access to any part of a category.
 * Useful for sidebar visibility.
 */
export const hasCategoryAccess = (category: string): boolean => {
    const permissions = getStoredPermissions();
    const normalizedCategory = category.trim();
    const categoryKey = Object.keys(permissions).find(
        key => key.trim().toLowerCase() === normalizedCategory.toLowerCase()
    );

    return !!categoryKey && Array.isArray(permissions[categoryKey]);
};
